export function makeAnalyticsUrls(analyticsServer) {
    const baseServer = analyticsServer + '/backoffice/proxy';
    return {
        blackQuery: {
            alert: baseServer + '/core-basic-api/export/black/query/alert',
        },
        coreSearch: {
            postQueryCompanyInfo: baseServer + '/search/corporate-tree/records/fetch',
            postQueryKeyword: baseServer + '/search/corporate-tree/records/fetch/detail',
        },
        // prompt管理
        prompt: {
            publishPrompt: '/core-basic-api/analytics/prompt/receive',
        },
        // 邮件模板
        emailTemplate: {
            publishTemplate: '/core-basic-api/analytics/email-template/receive',
        },
    };
}
